module.exports = __webpack_public_path__ + "static/EUR-2-front-db482d902173a5cf7248d2aaea7a4e2a.png";